import React from 'react';

interface RecipientTableProps {
  recipients: {
    id: string;
    email: string;
    username: string;
    fullName: string;
    status?: 'unsent' | 'sent' | 'fail';
  }[];
  showStatus?: boolean; // Optional prop to show/hide status column
}

const RecipientTable: React.FC<RecipientTableProps> = ({ recipients, showStatus = false }) => {
  const getStatusBadge = (status?: 'unsent' | 'sent' | 'fail') => {
    if (!status) return null;
    
    const statusConfig = {
      sent: { bg: 'bg-green-100', text: 'text-green-800', label: 'Sent' },
      unsent: { bg: 'bg-gray-100', text: 'text-gray-800', label: 'Unsent' },
      fail: { bg: 'bg-red-100', text: 'text-red-800', label: 'Failed' },
    };

    const config = statusConfig[status];
    
    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
        {config.label}
      </span>
    );
  };

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-200 rounded-lg">
        <thead className="bg-purple-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              No
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Email
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Username
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Full Name
            </th>
            {showStatus && (
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Status
              </th>
            )}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {recipients.map((recipient, index) => (
            <tr key={recipient.id}>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {index + 1}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {recipient.email}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {recipient.username}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                {recipient.fullName}
              </td>
              {showStatus && (
                <td className="px-6 py-4 whitespace-nowrap text-sm">
                  {getStatusBadge(recipient.status)}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RecipientTable;
